import { useState, useEffect } from 'react';
import { BaseEntityPage } from '../../components/common';
import { Top149Content } from './components';
import { useAppSelector } from '../../store/hooks';

export default function Top149Page() {
	const years = useAppSelector((state) => state.filters.years);
	const [yearsAchieveTop149, setYearsAchieveTop149] = useState<number | undefined>(undefined);
	const PAGE_PADDING = { xs: 1.5, sm: 2, md: 3 };

	useEffect(() => {
		if (yearsAchieveTop149 === undefined && years.length > 0) {
			setYearsAchieveTop149(years[0]);
		}
	}, [years, yearsAchieveTop149]);

	return (
		<BaseEntityPage
			ContentComponent={Top149Content}
			contentProps={{
				yearsAchieveTop149,
				setYearsAchieveTop149,
				availableYears: years
			}}
			sx={{ p: PAGE_PADDING }}
		/>
	);
}